import '@/utils/main';

import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import { store } from './store';
import './axios';

import '@/utils/vue-clipboard2';

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
